export default __webpack_public_path__ + "static/media/tile003.06d268b2.png";